import { render, staticRenderFns } from "./cheguaDetail.vue?vue&type=template&id=2bcb2580&scoped=true&"
import script from "./cheguaDetail.vue?vue&type=script&lang=js&"
export * from "./cheguaDetail.vue?vue&type=script&lang=js&"
import style0 from "./cheguaDetail.vue?vue&type=style&index=0&id=2bcb2580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb2580",
  null
  
)

export default component.exports